var _rect, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppointmentsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 57,
    viewBox: "0 0 57 57",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.353516,
    y: 0.304688,
    width: 56.6202,
    height: 55.7623,
    rx: 10,
    fill: "#F6F8FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.4108 18.0148H18.525C17.8584 18.0148 17.4141 17.5705 17.4141 16.9039C17.4141 16.2373 17.8584 15.793 18.525 15.793H37.4108C38.0774 15.793 38.5217 16.2373 38.5217 16.9039C38.5217 17.5705 38.0774 18.0148 37.4108 18.0148Z",
    fill: "#F2D4B7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7874 43.5816L40.6965 40.5151C41.4692 39.42 41.8004 38.2153 41.8004 36.9011C41.8004 33.287 38.8199 30.3301 35.2874 30.3301C31.755 30.3301 28.6641 33.287 28.6641 36.9011C28.6641 40.5151 31.6446 43.4721 35.177 43.4721C36.5017 43.4721 37.8264 43.034 38.8199 42.3769L41.9108 45.4434C42.3523 45.8815 43.2355 45.8815 43.677 45.4434C44.229 44.8958 44.229 44.0197 43.7874 43.5816Z",
    fill: "#F2D4B7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5194 36.5812C26.5194 31.7281 30.5904 27.7573 35.453 27.7573C36.6969 27.7573 37.8278 27.9779 38.9586 28.4191V20.0364C38.9586 19.3746 38.5063 18.9334 37.8278 18.9334H20.8651H18.6035C17.3595 18.9334 16.3418 17.9407 16.3418 16.7274C16.3418 15.5141 17.3595 14.5214 18.6035 14.5214H37.8278C38.5063 14.5214 38.9586 14.0802 38.9586 13.4184C38.9586 12.7566 38.5063 12.3154 37.8278 12.3154H18.6035C16.1156 12.3154 14.0801 14.3008 14.0801 16.7274V38.7872C14.0801 41.2138 16.1156 43.1992 18.6035 43.1992H20.8651H29.6857C27.7633 41.5447 26.5194 39.2284 26.5194 36.5812Z",
    fill: "#577CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointmentsIcon);
export default __webpack_public_path__ + "static/media/appointments_icon.8097a99f27addfd065050731558ce534.svg";
export { ForwardRef as ReactComponent };